import PropTypes from 'prop-types';
import { Title } from '@mantine/core';
import styles from './style.module.css';

const MenuGroups = (props) => {
  const {
    data = [],
    onClick = () => {},
    active,
  } = props;

  const onLinkClick = (e) => {
    e.preventDefault();
    const { target } = e;
    const { id } = target.dataset;
    onClick(id);
  };

  return (
    <>
      {data.map((item, index) => (
        <div className={styles.menugroup} key={index}>
          {item.title && <Title order={5}>{item.title}</Title>}
          {(item.links).map((link) => (
            <a
              key={link.id}
              href="#"
              className={styles.link}
              data-id={link.id}
              data-active={active === link.id || undefined}
              onClick={onLinkClick}
            >
              {link.title}
            </a>
          ))}
        </div>
      ))}
    </>
  );
};

MenuGroups.propTypes = {
  data: PropTypes.array,
  onClick: PropTypes.func,
  active: PropTypes.string,
};

export default MenuGroups;
